export function register() {
    if ("serviceWorker" in navigator) {
           
            navigator.serviceWorker.register("/service-worker.js")
                .then((registration) => {
                    if (registration.waiting) {
                        registration.waiting.postMessage({type: "SKIP_WAITING"});
                        return;
                    }
                    registration.onupdatefound = () => {
                        const installingWorker = registration.installing;
                        if(!installingWorker){
                            return;
                        }
                        installingWorker.onstatechange = () => {
                            if (installingWorker.state === "installed" && navigator.serviceWorker.controller) {
                                    installingWorker.postMessage({type: "SKIP_WAITING"});
                            }
                        };
                    }
                })
                .catch((error) => {
                    console.error("Service worker registration failed with error: ", error);
                });
            navigator.serviceWorker.addEventListener("controllerchange", event => {
                console.log("Service worker registration activated, reloading page...");
                window.location.reload();
            })
    }
    
}
